export type Source = 'app' | 'web';

const PREFIXES: Record<Source, string> = {
  web: '/asa-million-pound-challenge',
  app: '/asa-million-pound-challenge/appview',
};

export const getRoute = (source: Source, path = '') => `${PREFIXES[source]}${path}`;
